module.exports = __webpack_public_path__ + "static/media/icon-download.2a18a31b.svg";